import { render } from "./Dataset.vue?vue&type=template&id=22204934&scoped=true"
import script from "./Dataset.vue?vue&type=script&lang=js"
export * from "./Dataset.vue?vue&type=script&lang=js"

import "./Dataset.vue?vue&type=style&index=0&id=22204934&scoped=true&lang=css"

import exportComponent from "/home/jym/canvas_lms/lms/canvas/course_category_front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22204934"]])

export default __exports__